import { TOGGLE_SIDEBAR } from '../constants/constants';

const initialState = {
  expand: true, // Default sidebar to expanded
};

export const sidebarReducer = (state = initialState, action) => {
  switch (action.type) {
    case TOGGLE_SIDEBAR:
      return {
        ...state,
        expand: !state.expand,
      };
    default:
      return state;
  }
};